module.exports = __webpack_public_path__ + "static/media/aristoteles_desc1.6be9bb35.png";